// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".stacked-layout[data-v-94b6df40]{flex-direction:column!important}.v-tabs[data-v-94b6df40],.v-tabs-items[data-v-94b6df40]{width:100%!important;flex:none!important}", ""]);
// Exports
module.exports = exports;
